import React from 'react';
import { createMergingContextProvider } from '@wix/da-react-context/pkg/helpers';
export const propsDefaults = {
    showLikeButton: true,
    showAwardBadgeButton: true
};
export const CommentFeaturesContext = /*#__PURE__*/ React.createContext(propsDefaults);
CommentFeaturesContext.displayName = 'CommentFeaturesContext';
export const CommentFeaturesContextProvider = createMergingContextProvider(CommentFeaturesContext);
